<div class="aph">
  <strong class="aph-title"><span class="aph-star">✦</span><span class="aph-text">YOUR FAN PULSE</span></strong>
  <button type="button" class="aph-close" matTooltip="Close" aria-label="Close" (click)="close.emit()">
    <span class="material-icons">close</span>
  </button>
</div>
